import { Provider } from '@angular/core';
import { TradingProcedureService } from '../services/trading-procedure.service';
import { TRADING_PROCEDURE_SERVICE } from '../tokens/trading-procedure-service.token';

export function provideTradingProcedureService(): Provider {
    return {
        provide: TRADING_PROCEDURE_SERVICE,
        useClass: TradingProcedureService,
    };
}
